import { Alert, Conditional, Field } from '@payaca/ambrosia';
import TagSelectCombobox from '@payaca/components/tagSelectCombobox/TagSelectCombobox';
import { FC } from 'react';

export type MaterialTagOption = {
  id: number;
  tagText: string;
  tagColour: string;
};

type MaterialTag = {
  id: number | string;
  name: string;
  colour?: string | null;
};

/**
 * Maps material tags to the `MaterialTagOption` shape the filter combobox expects,
 * deduped by tag id so a tag shared across materials appears once.
 */
export const toMaterialTagOptions = (
  tags: MaterialTag[]
): MaterialTagOption[] => [
  ...new Map(
    tags.map((tag) => [
      +tag.id,
      {
        id: +tag.id,
        tagText: tag.name,
        tagColour: tag.colour || '#000000',
      },
    ])
  ).values(),
];

type Props = {
  availableTags: MaterialTagOption[];
  value: number[];
  onChange: (value: number[]) => void;
};

/**
 * "Filter by tags" control shared by the purchase order flows. Presentational:
 * the consumer supplies the tags available to filter by and owns the form
 * wiring. Falls back to a prompt when none of the materials carry tags.
 */
const MaterialTagFilter: FC<Props> = ({ availableTags, value, onChange }) => (
  <Field className="mb-2.5" name="tagIds">
    <Field.Label>Filter by tags</Field.Label>
    <Conditional
      condition={availableTags.length > 0}
      fallback={
        <Alert colour="yellow">
          <p>Add tags to your materials to filter by them</p>
        </Alert>
      }
    >
      <TagSelectCombobox
        multiple
        value={value}
        onChange={onChange}
        availableTags={availableTags}
      />
    </Conditional>
  </Field>
);

export default MaterialTagFilter;
